function extractYouTubeId(url) {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    const paramId = urlObj.searchParams.get("v");
    if (paramId) return paramId;
    if (urlObj.hostname === "youtu.be") {
      const id = urlObj.pathname.substring(1);
      return id || null;
    }
    return null;
  } catch {
    let match = url.match(/youtube\.com\/watch\?v=([^&]+)/);
    if (match && match[1]) return match[1];
    match = url.match(/youtu\.be\/([^?&]+)/);
    if (match && match[1]) return match[1];
    return null;
  }
}

module.exports = { extractYouTubeId };
